import { from as from$ } from 'rxjs';

import EmsFacilityService from '../../../services/emsFacility.service';

export const getFacilities = query => from$(EmsFacilityService.getFacilities(query));

export const getEmsFacilityById = id => from$(EmsFacilityService.getEmsFacilityById(id));

export const getDepartments = id => from$(EmsFacilityService.getDepartments(id));
